const moment = require('moment')
moment.locale('ru')

export const months = {
  0: {
    full: 'Январь',
    short: 'Янв'
  },
  1: {
    full: 'Февраль',
    short: 'Фев'
  },
  2: {
    full: 'Март',
    short: 'Мар'
  },
  3: {
    full: 'Апрель',
    short: 'Апр'
  },
  4: {
    full: 'Май',
    short: 'Май'
  },
  5: {
    full: 'Июнь',
    short: 'Июн'
  },
  6: {
    full: 'Июль',
    short: 'Июл'
  },
  7: {
    full: 'Август',
    short: 'Авг'
  },
  8: {
    full: 'Сентябрь',
    short: 'Сен'
  },
  9: {
    full: 'Октябрь',
    short: 'Окт'
  },
  10: {
    full: 'Ноябрь',
    short: 'Ноя'
  },
  11: {
    full: 'Декабрь',
    short: 'Дек'
  }
}

export function humanizeDuration (fromMoment, toMoment) {
  const duration = moment.duration(toMoment.diff(fromMoment))
  return duration.isValid() ? duration.humanize() : null
}

export function daysDuration (fromMoment, toMoment) {
  const duration = moment.duration(toMoment.diff(fromMoment, 'days'), 'days')
  return duration.isValid() ? duration.asDays() : null
}

export function humanizeDaysDuration (fromMoment, toMoment) {
  const unit = 'days'
  const duration = moment.duration(toMoment.diff(fromMoment, unit), unit)
  if (duration.isValid()) {
    const days = duration.asDays()
    if (days === 0) {
      return '0 дней' // иначе возвращает "несколько секунд"
    } else {
      return moment.duration(days, unit).locale('ru').humanize()
    }
  } else {
    return null
  }
}
